/**
 * Shared position bookkeeping for reorderable RHF field arrays: swap the
 * two rows' position values first (through the caller's callbacks, which
 * own each site's write mechanism), then swap the array slots.
 * delta is -1 (up) or +1 (down).
 */
export function swapPositions({ readPosition, writePosition, swap, index, delta }) {
    const oldPosition = readPosition(index);
    writePosition(index, readPosition(index + delta));
    writePosition(index + delta, oldPosition);
    swap(index, index + delta);
}
